import { render, staticRenderFns } from "./RolesDrawerSideOverviewItem.vue?vue&type=template&id=3c99fc4a&scoped=true&"
import script from "./RolesDrawerSideOverviewItem.vue?vue&type=script&lang=js&"
export * from "./RolesDrawerSideOverviewItem.vue?vue&type=script&lang=js&"
import style0 from "./RolesDrawerSideOverviewItem.vue?vue&type=style&index=0&id=3c99fc4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c99fc4a",
  null
  
)

export default component.exports